<ion-list color="primary" lines="none" class="ion-no-padding" *ngIf="auth.user | async as user">
  <ion-item (click)="goDashboard()" color="primary" detail="false">
    <ion-icon src="assets/icons/home.svg" size="small" slot="start" class="ion-no-margin"></ion-icon>
    <ion-label class="ion-padding-start">Dashboard</ion-label>
  </ion-item>
  <ion-item (click)="goNotifications()" color="primary" detail="false">
    <ion-icon src="assets/icons/notifications-circle-outline.svg" size="small" slot="start" class="ion-no-margin ion-icon-custom"></ion-icon>
    <ion-label class="ion-padding-start">Notifications</ion-label>
  </ion-item>
  <ng-container *ngIf="user.giglister || user.gigster">
    <ion-item (click)="gigs = !gigs" color="primary" detail="false">
      <ion-icon src="assets/icons/gigs.svg" size="small" slot="start" class="ion-no-margin"></ion-icon>
      <ion-icon *ngIf="!gigs" color="tertiary" src="assets/icons/add.svg" size="small" slot="end"></ion-icon>
      <ion-icon *ngIf="gigs" color="tertiary" src="assets/icons/remove.svg" size="small" slot="end"></ion-icon>
      <ion-label class="ion-padding-start"><strong *ngIf="gigs">Gigs</strong><span *ngIf="!gigs">Gigs</span></ion-label>
    </ion-item>
    <ion-list class="ion-no-padding" *ngIf="gigs">
      <ion-item *ngIf="!user.welcome && user.giglister" routerDirection="root" routerLink="/account/gigs/create" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>List a Gig</ion-label>
      </ion-item>
      <ion-item *ngIf="!user.welcome && user.giglister" routerDirection="root" routerLink="/account/gigs/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>My Listed Gigs</ion-label>
      </ion-item>
      <ion-item routerDirection="root" routerLink="/gigs/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>Available Gigs</ion-label>
      </ion-item>
      <ion-item *ngIf="!user.welcome && user.gigster" routerDirection="root" routerLink="/account/gigs/feed/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>My Applications</ion-label>
      </ion-item>
    </ion-list>
  </ng-container>
  <ng-container *ngIf="user.joblister || user.jobhunter">
    <ion-item (click)="jobs = !jobs" color="primary" detail="false">
      <ion-icon src="assets/icons/jobs.svg" size="small" slot="start" class="ion-no-margin"></ion-icon>
      <ion-icon *ngIf="!jobs" color="tertiary" src="assets/icons/add.svg" size="small" slot="end"></ion-icon>
      <ion-icon *ngIf="jobs" color="tertiary" src="assets/icons/remove.svg" size="small" slot="end"></ion-icon>
      <ion-label class="ion-padding-start"><strong *ngIf="jobs">Jobs</strong><span *ngIf="!jobs">Jobs</span></ion-label>
    </ion-item>
    <ion-list class="ion-no-padding" *ngIf="jobs">
      <ion-item *ngIf="!user.welcome && user.joblister" routerDirection="root" routerLink="/account/jobs/create" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>List a Job</ion-label>
      </ion-item>
      <ion-item *ngIf="!user.welcome && user.joblister" routerDirection="root" routerLink="/account/jobs/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>My Listed Jobs</ion-label>
      </ion-item>
      <ion-item routerDirection="root" routerLink="/jobs/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>Available Jobs</ion-label>
      </ion-item>
      <ion-item *ngIf="!user.welcome && user.jobhunter" routerDirection="root" routerLink="/account/jobs/feed/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>My Applications</ion-label>
      </ion-item>
    </ion-list>
  </ng-container>
  <ng-container *ngIf="user.volunteer || user.volseeker">
    <ion-item (click)="vols = !vols" color="primary" detail="false">
      <ion-icon src="assets/icons/volunteers.svg" size="small" slot="start" class="ion-no-margin"></ion-icon>
      <ion-icon *ngIf="!vols" color="tertiary" src="assets/icons/add.svg" size="small" slot="end"></ion-icon>
      <ion-icon *ngIf="vols" color="tertiary" src="assets/icons/remove.svg" size="small" slot="end"></ion-icon>
      <ion-label class="ion-padding-start"><strong *ngIf="vols">Volunteers</strong><span *ngIf="!vols">Volunteers</span></ion-label>
    </ion-item>
    <ion-list class="ion-no-padding" *ngIf="vols">
      <ion-item *ngIf="!user.welcome && user.volseeker" routerDirection="root" routerLink="/account/volunteers/create" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>List Ad</ion-label>
      </ion-item>
      <ion-item *ngIf="!user.welcome && user.volseeker" routerDirection="root" routerLink="/account/volunteers/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>My Listed Ads</ion-label>
      </ion-item>
      <ion-item routerDirection="root" routerLink="/volunteers/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>Available Ads</ion-label>
      </ion-item>
      <ion-item *ngIf="!user.welcome && user.volunteer" routerDirection="root" routerLink="/account/volunteers/feed/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>My Applications</ion-label>
      </ion-item>
    </ion-list>
  </ng-container>
  <ng-container *ngIf="user.promoter">
    <ion-item (click)="ads = !ads" color="primary" detail="false">
      <ion-icon src="assets/icons/promote.svg" size="small" slot="start" class="ion-no-margin"></ion-icon>
      <ion-icon *ngIf="!ads" color="tertiary" src="assets/icons/add.svg" size="small" slot="end"></ion-icon>
      <ion-icon *ngIf="ads" color="tertiary" src="assets/icons/remove.svg" size="small" slot="end"></ion-icon>
      <ion-label class="ion-padding-start"><strong *ngIf="ads">Promote</strong><span *ngIf="!ads">Promote</span></ion-label>
    </ion-item>
    <ion-list class="ion-no-padding" *ngIf="ads">
      <ion-item *ngIf="!user.welcome && user.promoter" routerDirection="root" routerLink="/account/promote/create" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>List Ad</ion-label>
      </ion-item>
      <ion-item *ngIf="!user.welcome && user.promoter" routerDirection="root" routerLink="/account/promote/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>My Listed Ads</ion-label>
      </ion-item>
      <ion-item routerDirection="root" routerLink="/promote/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>Available Ads</ion-label>
      </ion-item>
      <ion-item *ngIf="!user.welcome" routerDirection="root" routerLink="/account/promote/feed/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>My Applications</ion-label>
      </ion-item>
    </ion-list>
  </ng-container>
  <ng-container *ngIf="!user.welcome && (user.giglister || user.gigster || user.joblister || user.promoter)">
    <ion-item (click)="payments = !payments" color="primary" detail="false">
      <ion-icon src="assets/icons/payment.svg" size="small" slot="start" class="ion-no-margin"></ion-icon>
      <ion-icon *ngIf="!payments" color="tertiary" src="assets/icons/add.svg" size="small" slot="end"></ion-icon>
      <ion-icon *ngIf="payments" color="tertiary" src="assets/icons/remove.svg" size="small" slot="end"></ion-icon>
      <ion-label class="ion-padding-start"><strong *ngIf="payments">Payments</strong><span *ngIf="!payments">Payments</span></ion-label>
    </ion-item>
    <ion-list class="ion-no-padding" *ngIf="payments">
      <ion-item  *ngIf="user.giglister || user.joblister || user.promoter" routerDirection="root" routerLink="/account/payments/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>My Expenses</ion-label>
      </ion-item>
      <ion-item *ngIf="user.gigster" routerDirection="root" routerLink="/account/payouts/" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>My Income</ion-label>
      </ion-item>
    </ion-list>
  </ng-container>
  <ng-container>
    <ion-item (click)="support = !support" color="primary" detail="false">
      <ion-icon src="assets/icons/help-circle-outline.svg" size="small" slot="start" class="ion-no-margin ion-icon-custom"></ion-icon>
      <ion-icon *ngIf="!support" color="tertiary" src="assets/icons/add.svg" size="small" slot="end"></ion-icon>
      <ion-icon *ngIf="support" color="tertiary" src="assets/icons/remove.svg" size="small" slot="end"></ion-icon>
      <ion-label class="ion-padding-start"><strong *ngIf="support">Support</strong><span *ngIf="!support">Support</span></ion-label>
    </ion-item>
    <ion-list class="ion-no-padding" *ngIf="support">
      <ion-item routerDirection="root" href="/support" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>Help Centre</ion-label>
      </ion-item>
      <ion-item routerDirection="root" href="/faqs" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>FAQs</ion-label>
      </ion-item>
      <ion-item routerDirection="root" href="/how-it-works" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>How it works</ion-label>
      </ion-item>
      <ion-item routerDirection="root" href="/pricing" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>Pricing</ion-label>
      </ion-item>
      <ion-item routerDirection="root" routerLink="/contact" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>Contact Us</ion-label>
      </ion-item>
    </ion-list>
  </ng-container>
  <ng-container>
    <ion-item (click)="company = !company" color="primary" detail="false">
      <ion-icon src="assets/icons/information-circle-outline.svg" size="small" slot="start" class="ion-no-margin ion-icon-custom"></ion-icon>
      <ion-icon *ngIf="!company" color="tertiary" src="assets/icons/add.svg" size="small" slot="end"></ion-icon>
      <ion-icon *ngIf="company" color="tertiary" src="assets/icons/remove.svg" size="small" slot="end"></ion-icon>
      <ion-label class="ion-padding-start"><strong *ngIf="company">Company</strong><span *ngIf="!company">Company</span></ion-label>
    </ion-item>
    <ion-list class="ion-no-padding" *ngIf="company">
      <ion-item routerDirection="root" href="/terms-conditions" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>Terms & Conditions</ion-label>
      </ion-item>
      <ion-item routerDirection="root" href="/privacy-policy" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>Privacy Policy</ion-label>
      </ion-item>
    </ion-list>
  </ng-container>
  <ng-container>
    <ion-item (click)="profile = !profile" color="primary" detail="false">
      <ion-icon src="assets/icons/profile.svg" size="small" slot="start" class="ion-no-margin"></ion-icon>
      <ion-icon *ngIf="!profile" color="tertiary" src="assets/icons/add.svg" size="small" slot="end"></ion-icon>
      <ion-icon *ngIf="profile" color="tertiary" src="assets/icons/remove.svg" size="small" slot="end"></ion-icon>
      <ion-label class="ion-padding-start"><strong *ngIf="profile">Profile</strong><span *ngIf="!profile">Profile</span></ion-label>
    </ion-item>
    <ion-list class="ion-no-padding" *ngIf="profile">
      <ion-item routerDirection="root" routerLink="/account/profile" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>My Profile</ion-label>
      </ion-item>
      <ion-item routerDirection="root" routerLink="/account/delete" color="primary" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>Delete Profile</ion-label>
      </ion-item>
      <ion-item color="primary" (click)="logout()" detail="false">
        <ion-icon src="assets/icons/chevron-forward.svg" size="small" slot="start" class="ion-padding-start ion-no-margin ion-margin-start"></ion-icon>
        <ion-label>Sign Out</ion-label>
      </ion-item>
    </ion-list>
  </ng-container>
</ion-list>
<fab-account></fab-account>